import { Box, Loader } from '@wix/design-system';
import { WIX_STUDIO_HEADER_HEIGHT } from '@wix/core-domain-search';
import { DomainSearchSuiteModule, Statuses } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { useDomainPermissions } from '@wix/my-domains-shared-components/@common-plugins/useDomainPermissions';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import React, { useMemo } from 'react';
import { ResultsLayout, ResultsRecommendations, ResultsSearchBar } from '../ResultsLayout';
import { buildMobileConnectStatus } from './mobileConnectStatus';
import { mobileUpgradeRequireAssignStatus } from './mobileUpgradeAssignStatus';
import { LoggedInMobileVoucherBanner } from '../../Components/VoucherBanner';
import { getLoggedInMobileStatusesConfiguration } from '../../Components';
import { ExperimentSpecs } from '../../constants';
import { mobileUpgradeRequireConnectStatus } from './mobileUpgradeConnectStatus';
export const LoggedInMobileResultsPage = _ref => {
  var _getPremiumEssentials;
  let {
    handlers,
    externalViewer = false,
    onConnectIntro,
    onConnectManual,
    onConnectError
  } = _ref;
  const isConnectEnabled = Boolean((_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.LoggedInMobileConnect]);
  const customConfiguration = useMemo(() => getLoggedInMobileStatusesConfiguration({
    isConnectEnabled
  }), [isConnectEnabled]);

  // Override the `connect` action itself (not just its card) so clicking the
  // results card runs the mobile Entri divert — the same action
  // `SelectSiteRoute` runs imperatively after a site is picked.
  const statusesOverrides = useMemo(() => isConnectEnabled ? {
    connect: buildMobileConnectStatus({
      onConnectIntro,
      onConnectManual,
      onConnectError
    }),
    transfer: Statuses.connect
  } : {
    upgradeRequireAssign: mobileUpgradeRequireAssignStatus,
    upgradeRequireConnect: mobileUpgradeRequireConnectStatus
  }, [isConnectEnabled, onConnectIntro, onConnectManual, onConnectError]);
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, null, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer
      },
      handlers,
      statusesOverrides
    },
    statusesCustomComponents: {
      customConfiguration
    }
  }, /*#__PURE__*/React.createElement(LoggedInMobileResultsPageContent, null)));
};
const LoggedInMobileResultsPageContent = () => {
  var _getPremiumEssentials2;
  const {
    canManageDomains,
    isLoading,
    error,
    refetch
  } = useDomainPermissions();
  const isOptimized = Boolean((_getPremiumEssentials2 = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials2 = _getPremiumEssentials2.experiments) == null ? void 0 : _getPremiumEssentials2[ExperimentSpecs.DomainMobileFlowLoggedInOptimizations]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Box, {
      height: `calc(100dvh - ${WIX_STUDIO_HEADER_HEIGHT})`,
      align: "center",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  if (error) {
    return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.TechnicalIssue, {
      onRetry: () => refetch()
    });
  }
  if (!canManageDomains()) {
    return /*#__PURE__*/React.createElement(Box, {
      height: `calc(100dvh - ${WIX_STUDIO_HEADER_HEIGHT})`
    }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.NoPermissionsBlock, null));
  }
  return /*#__PURE__*/React.createElement(ResultsLayout, {
    biViewMode: "Gate Result Page",
    reportGatePageLoadEvents: false,
    useReferralAdditionalInfoAsSearchOrigin: true,
    querySubmitPath: "/results",
    deviceType: "Smartphone",
    stickyHeaderOffset: WIX_STUDIO_HEADER_HEIGHT,
    isResultsPageOptimizations: isOptimized,
    searchBar: /*#__PURE__*/React.createElement(ResultsSearchBar, {
      showUnassignedDomainsOnEmptyInput: true
    }),
    voucher: /*#__PURE__*/React.createElement(LoggedInMobileVoucherBanner, {
      isOptimized: isOptimized
    })
  }, /*#__PURE__*/React.createElement(ResultsRecommendations, {
    showHeroCard: isOptimized,
    hideAiInsights: isOptimized
  }));
};
//# sourceMappingURL=LoggedInMobileResultsPage.js.map